import connect from './connect'
import ClientSearch from './ClientSearch'

export default connect(ClientSearch)
